
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.13 33.94"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#5ad8a7","d":"M35.06 0L14.81 20.25l-4.47-3.94-3.75-3.28L0 20.56l3.78 3.28 8 7 3.5 3.1L42.13 7.09 35.06 0z"}})])
          )
        }
      }
    